"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("@xstyled/styled-components"));
var system_1 = require("@xstyled/system");
var Frame_1 = __importDefault(require("../Frame/Frame"));
var Icon_1 = __importDefault(require("../Icon"));
var Button = styled_components_1.default(Frame_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 2 3;\n  margin-right: 2;\n  max-width: 150px;\n  border: none;\n  outline: none;\n\n  ", "\n\n  ", "\n"], ["\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 2 3;\n  margin-right: 2;\n  max-width: 150px;\n  border: none;\n  outline: none;\n\n  ",
    "\n\n  ",
    "\n"])), function (_a) {
    var small = _a.small;
    return !small
        ? "\n    width: 100%;\n  "
        : '';
}, function (_a) {
    var active = _a.active, small = _a.small;
    return active && small
        ? styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          outline: ", "px dotted ", ";\n          outline-offset: -", "px;\n          padding-top: 4;\n          padding-right: 2;\n          padding-bottom: 0;\n          padding-left: 4;\n        "], ["\n          outline: ", "px dotted ", ";\n          outline-offset: -", "px;\n          padding-top: 4;\n          padding-right: 2;\n          padding-bottom: 0;\n          padding-left: 4;\n        "])), system_1.th('space.1'), system_1.th('colors.black'), system_1.th('space.4')) : '';
});
var WindowButton = function (_a) {
    var _b = _a.children, children = _b === void 0 ? '' : _b, small = _a.small, _c = _a.icon, icon = _c === void 0 ? 'bat_exec_32x32_4bit' : _c, active = _a.active, props = __rest(_a, ["children", "small", "icon", "active"]);
    return (react_1.default.createElement(Button, __assign({ active: active, small: small }, (active
        ? {
            boxShadow: 'in',
            bg: small ? undefined : 'grays.0',
        }
        : {
            boxShadow: 'out',
        }), props, { as: "button" }),
        react_1.default.createElement(Icon_1.default, { name: icon, style: { marginRight: 4, minWidth: 20, width: 20, height: 20 } }),
        children));
};
WindowButton.defaultProps = {
    small: false,
    icon: 'bat_32x32_4bit',
    active: false,
};
exports.default = WindowButton;
var templateObject_1, templateObject_2;
//# sourceMappingURL=WindowButton.js.map